<ion-header mode="md" color="primary">
    <ion-toolbar mode="md" color="lightblue">
        <ion-title class="ion-text-center" color="light">
            {{ 'generic.frozenStructureSync' | translate }}
        </ion-title>
    </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
    <ion-item lines="none" class="ion-text-center upper">
        <div class="sync-enabled" [ngClass]="frozenStructure.Enabled ? '' : 'centralize-toggle'">
            <span>{{ "frozenStructure.isEnabled" | translate }}</span>
            <ion-toggle class="custom-toggle" [(ngModel)]="frozenStructure.Enabled">
            </ion-toggle>
        </div>
    </ion-item>
    <ng-container *ngIf="frozenStructure.Enabled">
        <ion-row>
            <ion-col size="6">
                <ion-item lines="none" class="upper">
                    <ion-label position="stacked">
                        {{ "frozenStructure.begins" | translate }}
                    </ion-label>
                    <mat-form-field>
                        <input matInput [ngxMatDatetimePicker]="pickerFrozenStructureStartDate"
                               [(ngModel)]="frozenStructure.StartDate"
                               readonly>
                        <mat-datepicker-toggle matSuffix [for]="$any(pickerFrozenStructureStartDate)">
                        </mat-datepicker-toggle>
                        <ngx-mat-datetime-picker #pickerFrozenStructureStartDate
                                                 [showSpinners]="true"
                                                 [disableMinute]="false"
                                                 [showSeconds]="true"
                                                 [touchUi]="false"
                                                 [enableMeridian]="false">
                        </ngx-mat-datetime-picker>
                    </mat-form-field>
                </ion-item>
            </ion-col>
            <ion-col size="6">
                <ion-item lines="none" class="upper">
                    <ion-label position="stacked">
                        {{ "frozenStructure.ends" | translate }}
                    </ion-label>
                    <mat-form-field>
                        <input matInput [ngxMatDatetimePicker]="pickerFrozenStructureEndDate"
                               [(ngModel)]="frozenStructure.EndDate"
                              readonly >
                        <mat-datepicker-toggle matSuffix [for]="$any(pickerFrozenStructureEndDate)">
                        </mat-datepicker-toggle>
                        <ngx-mat-datetime-picker #pickerFrozenStructureEndDate
                                                 [showSpinners]="true"
                                                 [disableMinute]="false"
                                                 [showSeconds]="true"
                                                 [touchUi]="false"
                                                 [enableMeridian]="false">
                        </ngx-mat-datetime-picker>
                    </mat-form-field>
                </ion-item>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col size="6">
                <ion-item lines="none" class="upper">
                    <ion-label position="stacked">
                        {{ "frozenStructure.totalFreezingBegins" | translate }}
                    </ion-label>
                    <mat-form-field>
                        <input matInput [ngxMatDatetimePicker]="pickerFrozenStructureTotalFreezingStartDate"
                               [(ngModel)]="frozenStructure.TotalFreezingStartDate" readonly>
                        <mat-datepicker-toggle matSuffix [for]="$any(pickerFrozenStructureTotalFreezingStartDate)">
                        </mat-datepicker-toggle>
                        <ngx-mat-datetime-picker #pickerFrozenStructureTotalFreezingStartDate
                                                 [showSpinners]="true"
                                                 [disableMinute]="false"
                                                 [showSeconds]="true"
                                                 [touchUi]="false"
                                                 [enableMeridian]="false">
                        </ngx-mat-datetime-picker>
                    </mat-form-field>
                </ion-item>
            </ion-col>
            <ion-col size="6">
                <ion-item lines="none" class="upper">
                    <ion-label position="stacked">
                        {{ "frozenStructure.totalFreezingEnds" | translate }}
                    </ion-label>
                    <mat-form-field>
                        <input matInput [ngxMatDatetimePicker]="pickerFrozenStructureTotalFreezingEndDate"
                               [(ngModel)]="frozenStructure.TotalFreezingEndDate" readonly>
                        <mat-datepicker-toggle matSuffix [for]="$any(pickerFrozenStructureTotalFreezingEndDate)">
                        </mat-datepicker-toggle>
                        <ngx-mat-datetime-picker #pickerFrozenStructureTotalFreezingEndDate
                                                 [showSpinners]="true"
                                                 [disableMinute]="false"
                                                 [showSeconds]="true"
                                                 [touchUi]="false"
                                                 [enableMeridian]="false">
                        </ngx-mat-datetime-picker>
                    </mat-form-field>
                </ion-item>
            </ion-col>
        </ion-row>
    </ng-container>
</ion-content>
<ion-footer mode="ios">
    <ion-toolbar mode="ios">
        <ion-row>
            <ion-col size="6" style="text-align: left;">
                <ion-button color="primary" mode="ios" (click)="back()">
                    {{ 'generic.goBack' | translate }}
                </ion-button>
            </ion-col>
            <ion-col size="6" style="text-align: right;">
                <ion-button color="lightblue" mode="ios" (click)="saveFrozenStructure()">
                    {{ 'generic.save' | translate }}
                </ion-button>
            </ion-col>
        </ion-row>
    </ion-toolbar>
</ion-footer>
